export default __webpack_public_path__ + "static/media/down-arrow-icon.86c222df.svg";